<template>
  <div class="box green" v-if="data.contract">
    <div class="text-bold">{{ title }}: {{ data.contract.title }} <span v-if="data.contract.active === false" class="colRed">(UMAKNJENO)</span></div>
    <div class="padding-top10">Interna številka pogodbe: {{ data.contract.internalId }}</div>
    <div class="padding-top3">Številka javnega naročila: {{ data.contract.jnTitle }}</div>
    <div class="padding-top3">Naročnik: {{ data.contract.client?.title }}</div>
    <div class="padding-top3">Izvajalec: {{ data.contract.contractor }}</div>
    <div class="padding-top3">Znesek pogodbe: {{ formatNumber(data.contract.value, 2) }} EUR</div>
    <div class="padding-top3">Trajanje pogodbe: {{ formatDate(data.contract.dateFrom) }} - {{ formatDate(data.contract.dateTo) }}</div>
    <div class="padding-top3" v-if="data.contract.active === true"><a target="_blank" :href="$appData.pjnUrl + data.contract.idPjn">Pogodba objavljena na portalu javnih naročil</a></div>
  </div>
</template>

<script lang="ts">
import { formatDate, formatNumber } from '@/lib/filters'
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    data: {},
    title: { default: 'Naziv pogodbe' }
  },
  setup() {
    return { formatDate, formatNumber }
  }
})
</script>
